import { Component, inject, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { LegalLinksContainerComponent } from '../../../../../shared/components/legal-links-container/legal-links-container.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-mail-sent',
  imports: [LegalLinksContainerComponent, TranslocoDirective],
  templateUrl: './mail-sent.component.html',
  styleUrl: './mail-sent.component.css',
  standalone: true
})
export class MailSentComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  public email = '';

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParams['email'] || '';
  }
}
